import { dew as _LogLevelDew } from "./LogLevel";
import { dew as _NoOpLoggerDew } from "./NoOpLogger";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const LogLevel_1 = __importDefault(_LogLevelDew());
  const NoOpLogger_1 = __importDefault(_NoOpLoggerDew());
  /**
   * [[NoOpDebugLogger]] does not log any message but does call
   * debug functions by default.
   */
  class NoOpDebugLogger extends NoOpLogger_1.default {
    constructor() {
      super(LogLevel_1.default.DEBUG);
    }
  }
  exports.default = NoOpDebugLogger;
  //# sourceMappingURL=NoOpDebugLogger.js.map
  return exports;
}